module.exports = __webpack_public_path__ + "static/img/banner-csr-04.c9a6070.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-csr-04.jpg
// module id = cFd6
// module chunks = 98